/**
 * Tagalog UI translations.
 *
 * These keys are loaded when the learner's mother tongue is set to `tl`.
 * Language names (language_fr/en/es) use the Filipino exonyms (Pranses/Ingles/
 * Espanyol) so they read naturally inside Tagalog sentences.
 */
export const tagalogTranslations = {
  confirmReset: "Sigurado ka bang gusto mong i-reset?",
  confirmEndActivity: "Matatapos ang kasalukuyang aktibidad mo. Sigurado ka ba?",
  confirmEndOnboarding: "Inirerekomenda naming tapusin ang panimulang pag-uusap na ito. Ilang minuto lang ito at makakatulong para ma-personalize ang iyong pag-aaral. Sigurado ka bang gusto mong ihinto?",
  onboarding_complete_title: "Mahusay!",
  onboarding_complete_body: "Natapos mo na ang unang pag-uusap. Gumagawa na kami ngayon ng personalized na plano sa pag-aaral batay sa natutunan namin tungkol sa iyo.",
  planner_edit_hint: "Maaari mong i-edit ang layuning ito anumang oras.",
  objective_generating: "Binubuo namin ang personalized mong plano sa pag-aaral...",
  objective_generating_1: "Sinusuri ang mga layunin mo sa pag-aaral...",
  objective_generating_2: "Pumipili ng mga aktibidad na akma sa level mo...",
  objective_generating_3: "Gumagawa ng curriculum para sa iyo...",
  objective_generating_4: "Pumipili ng bokabularyong may kaugnayan sa trabaho mo...",
  objective_generating_5: "Inaayos ang learning path mo nang sunod-sunod...",
  objective_generating_6: "Malapit na! Tinatapos na ang plano...",
  objective_ready: "Handa na ang plano sa pag-aaral mo!",
  objective_continue: "Simulan ang pag-aaral",
  objective_timeout: "Masyadong nagtagal ang paggawa ng plano. Maaari kang gumawa ng isa mula sa main app.",
  objective_activities_count: "{{count}} aktibidad ang nakaplano para sa iyo",
  confirmReplaceLearningPlan: "Papalitan nito ang kasalukuyan mong plano sa pag-aaral at lahat ng progress. Sigurado ka ba?",
  yes: "Oo",
  commencer: "Magsimula",
  remind_me_later: "Ipaalala sa akin mamaya",
  continue_your_learning_plan: "Ipagpatuloy ang plano sa pag-aaral mo",
  start_your_learning_plan: "Simulan ang plano sa pag-aaral mo",
  commencer_select_activity: "Tingnan ang lahat ng aktibidad",
  or: "o",
  warning_volume: "Siguraduhing naka-on ang volume at mikropono mo!",
  ai_can_make_mistakes: "Natututo rin si Madame AI! Tulad ng maraming AI tools, maaari siyang magkamali",
  initial_text: "I-click ang berdeng button at sabihin ang \"{{targetGreeting}}\"",
  end_conversation: "Matatapos ang pag-uusap na ito. Sigurado ka ba?",
  end_conversation_action: "Tingnan ang plano sa pag-aaral ko",
  preparing_your_plan: "Inihahanda ang plano mo...",
  time_remaining: "Natitirang Oras",
  end_label: "Tapusin",
  activity_start_conversation: "Freeform na pag-uusap",
  activity_coming_soon: "Malapit na",
  activity_tutorial: "Tutorial",
  cancel: "Kanselahin",
  new_conversation: "Bagong Pag-uusap",
  reset_conversation: "I-reset ang Lahat",
  restart_onboarding: "Ulitin ang Onboarding",
  status_disconnected: "Nadiskonekta ka. Subukang magsalita muli o i-refresh ang page",
  status_listening: "nakikinig...",
  status_speaking: "nagsasalita!",
  status_prefix: "Si Madame AI ay",
  setting_native_language: "Katutubong wika",
  setting_target_language: "Wikang pag-aaralan",
  setting_realtime: "Realtime na pag-uusap",
  setting_microphone: "Mikropono",
  setting_group_conversation: "Pag-uusap",
  setting_microphone_system_default: "Default ng system",
  setting_microphone_change_hint_chrome: "Para palitan ang mikropono, i-click ang icon sa kaliwa ng address bar at buksan ang Site settings > Microphone, o buksan ang address na ito sa bagong tab:",
  setting_microphone_change_hint_generic: "Para palitan ang mikropono, buksan ang site settings ng browser mo (icon sa kaliwa ng address bar) > Microphone, o palitan ang default input sa sound settings ng system.",
  setting_use_custom_agent: "Gumamit ng Custom Agent",
  premium_feature: "Premium na feature",
  language_variant: "Variant ng wika",
  language_france: "France",
  language_quebec: "Quebec",
  setting_echo_cancellation: "Echo cancellation",
  setting_noise_suppression: "Noise suppression",
  setting_auto_gain: "Auto gain control",
  stt_model_default: "Default",
  stt_model_conversaflex: "Conversaflex AI",
  setting_tts_speed: "Bilis ng pagsasalita",
  tts_speed_050: "Napakabagal (0.5x)",
  tts_speed_075: "Mas mabagal (0.75x)",
  tts_speed_085: "Bahagyang mas mabagal (0.85x)",
  tts_speed_100: "Normal (1x)",
  setting_hide_assistant_text: "Itago ang text ng assistant",
  setting_preferred_pronoun: "Mas gustong pronoun",
  pronoun_unspecified: "Hindi tinukoy",
  pronoun_masculine: "Masculine (il)",
  pronoun_feminine: "Feminine (elle)",
  pronoun_nonbinary: "They/Them (non-binary)",
  sign_out: "Mag-sign out",
  confirm_variant_change_title: "Palitan ang variant ng wika?",
  confirm_variant_change_body: "Kapag pinalitan ang variant ng wika sa realtime, magsisimula ang bagong pag-uusap. Gusto mo bang magpatuloy?",
  confirm_mode_change_title: "Palitan ang conversation mode?",
  confirm_mode_change_body: "Ire-reset nito ang kasalukuyan mong aktibidad at magsisimula ng bagong pag-uusap. Gusto mo bang magpatuloy?",
  confirm_restart: "Oo, ulitin",
  back: "Bumalik",
  close: "Isara",
  feedback_question: "Ano ang maaari naming gawin para mapabuti ang produkto?",
  feedback_description: "Magbigay ng maraming detalye hangga't maaari!",
  submit_feedback: "Isumite ang Puna",
  planner_question: "Ano ang learning objective mo?",
  planner_description: "Ipaliwanag sa ilang salita. Halimbawa: Gumawa ng presentation para sa client.",
  submit_objective: "Isumite ang Objective",
  last: "Magsimulang mag-practice!",
  next: "Susunod",
  nextLabelWithProgress: "Susunod (Hakbang {step} ng {steps})",
  open: "Buksan ang dialog",
  welcomeMessage: "Welcome sa Madame AI!",
  practiceMessage: "Mag-practice ng araw-araw na pag-uusap sa bagong wika nang walang takot na husgahan!",
  ageLabel: "Edad:",
  motherTongueLabel: "Mother tongue:",
  levelLabel: "Level:",
  getStarted: "Magsimula",
  beginner: "Beginner",
  intermediate: "Intermediate",
  advanced: "Advanced",
  termsMessage: "Nabasa ko ang terms at privacy policy",
  termsAgreement: "Nabasa ko at sumasang-ayon ako sa",
  startTutorial: "Simulan ang tutorial",
  skip: "Laktawan",
  infoTooltip: "Ini-save namin ang audio at conversation data kung adult ka para ma-customize ang AI para sa iyo at mai-save ang mahalagang impormasyon. Hindi namin sini-save ang audio kapag wala pang 18 ang learner.",
  adult: "Adult",
  step1Content: "Bonjour! Ito si Madame AI. Tutulungan ka niyang matuto at mag-practice ng French!",
  step2Content: "Nasa itaas ang mga opsyon. Pumunta rito para magsimula ng aktibidad, freeform na pag-uusap, o magpalit ng settings. Mas tuloy-tuloy ang Realtime mode at inirerekomenda para sa mas advanced na learners.",
  step3Content: "Kapag handa ka na, i-click ang \"Magsimula\"",
  tutorial_completed_title: "Magnifique!",
  tutorial_completed_message: "Congratulations sa pagtatapos ng aktibidad.\nMakakatanggap ka ng email summary sa lalong madaling panahon.\nBumalik sa listahan ng mga aktibidad para ipagpatuloy ang iyong learning journey.",
  go_to_activities: "Pumunta sa Mga Aktibidad",
  native_language_label: "Ano ang iyong katutubong wika?",
  email_capture_title: "Magsimula tayo!",
  email_capture_message: "Una, ilagay ang work email mo para magpatuloy:",
  first_name_placeholder: "Ilagay ang first name mo",
  email_placeholder: "Ilagay ang work email mo",
  continue_button: "Magpatuloy",
  invalid_email: "Maglagay ng valid na email address",
  email_consent_label: "Sumasang-ayon akong makatanggap ng follow-up emails tungkol sa serbisyong ito.",
  email_newsletter_label: "Isama ako sa newsletter",
  email_newsletter_note: "Paminsan-minsang emails kapag may bagong tests.",
  col_free_test: "Libreng Test",
  col_full_platform: "Full Platform",
  col_lite_version: "Lite Version",
  col_full_version: "Full Version",
  feature_lite_preview: "Silipin kung paano nagbabago ang language learning",
  feature_lite_slower: "Mas mabagal na interactions",
  feature_lite_one_activity: "Isang dynamic activity lang",
  feature_lite_no_domain: "Hindi nakaangkop sa work domain",
  feature_lite_no_test: "Walang placement test o analysis",
  feature_lite_no_memory: "Walang memory",
  feature_lite_no_feedback: "Walang analysis o feedback mula sa interactions mo",
  feature_activity_free_test: "Kumuha ng libreng placement test",
  feature_activity_retake: "Ulitin ang tests at subaybayan ang progress",
  feature_activity_personalized: "Personalized na learning activities",
  feature_activity_domain: "Nakaangkop sa work domain mo",
  feature_activity_memory: "AI memory sa pagitan ng mga pag-uusap",
  feature_activity_feedback: "Detalyadong feedback at analysis",
  email_capture_terms_prefix: "Sa pagpapatuloy, sumasang-ayon ka sa aming",
  email_capture_terms_link: "Terms of Service",
  email_capture_terms_and: "at",
  email_capture_privacy_link: "Privacy Policy",
  activities_work: "Mga aktibidad sa trabaho",
  activities_basic: "Mga pang-araw-araw na sitwasyon",
  activities_pitch: "Ang iyong sales pitch",
  activity_pitch_practice: "Sanayin ang iyong sales pitch",
  activity_travail: "Magsimula ng usapang may kaugnayan sa trabaho",
  activity_learning_path: "Ipagpatuloy ang learning path",
  activities_test_practices: "Mag-practice para sa test",
  // Everyday-situation activities
  activity_culture_social_norms: "Kultura at mga social norm",
  activity_greetings_introductions: "Pagbati at pagpapakilala",
  activity_numbers: "Mga numero, petsa at oras",
  activity_people_relationships: "Mga tao at relasyon",
  activity_food_drinks: "Pagkain at inumin",
  activity_places_directions_transport: "Lugar, direksyon at transportasyon",
  activity_appointments: "Mga appointment at phone call",
  activity_weather_small_talk: "Panahon at maikling usapan",
  activity_questions_requests_clarification: "Mga tanong, hiling at paglilinaw",
  activity_shopping_errands: "Pamimili at mga errand",
  activity_colors: "Mga kulay at paglalarawan",
  placement_test_completed: "Natapos mo ang aktibidad. Tingnan natin ang resulta mo!",
  placement_test_title: "Tapos na ang oras!",
  fallback_no_audio: "Hindi marinig, pakisubukang muli.",
  browser_not_supported: "Hindi sinusuportahan ng browser mo ang audio features. Subukan ang Chrome, Safari, o Firefox.",
  no_audio_detected: "Walang audio na na-detect. Pakisubukang magsalita muli.",
  audio_decode_error: "Hindi ma-process ang audio file. Pakisubukang mag-record muli.",
  recording_timeout: "Nag-time out ang koneksyon. Pakisubukang mag-record muli.",
  activity_start_timeout: "Hindi namin masimulan ang iyong activity. Pakisuri ang iyong koneksyon at subukan muli.",
  microphone_not_working: "Hindi umaabot sa amin ang mikropono mo. Pakireload ang page at magsimula ulit.",
  connection_error: "Connection error. Pakisubukang muli.",
  sending_for_analysis: "Ipinapadala ang pag-uusap para sa analysis...",
  max_recording_reached: "Naabot na ang maximum recording time na 50 segundo. Na-submit na ang audio mo.",
  recording_start_label: "Simulan ang pag-record",
  recording_stop_label: "Itigil ang pag-record",
  recording_hint_idle: "I-tap para mag-record, o pindutin nang matagal ang button habang nagsasalita ka.",
  recording_hint_stop: "I-tap ulit kapag tapos ka na.",
  recording_hint_release: "Bitawan ang button kapag tapos ka na.",
  recording_too_short: "Masyadong maikli para ipadala. I-tap nang isang beses para magsimulang mag-record.",
  placement_test_needed_title: "Bago ka magsimula",
  placement_test_needed_body: "Para maging mas accurate si Madame AI, hinihikayat ka naming kumuha ng placement test. Gusto mo bang magsimula ngayon?",
  test_results_title: "Tapos na ang Test",
  test_results_body: "Ina-analyze ang mga resulta mo. Matatanggap mo ang detalyadong resulta sa email at magiging available din ito sa dashboard mo.",
  test_results_ok: "Sige!",
  daily_limit_message: "Natapos mo na ang test na ito ngayong araw. Narito ang pinakabagong resulta mo. Bumalik bukas para subukang muli!",
  exam_results_pending: "Ina-analyze ang exam mo! Matatanggap mo ang detalyadong resulta sa email sa lalong madaling panahon. I-refresh ang page na ito mamaya para makita ang resulta.",
  conversation_feedback_title: "Kumusta ang pag-uusap mo?",
  star: "star",
  stars: "stars",
  submit: "Isumite",
  feedback_tags_label: "Ano ang naging problema?",
  feedback_tag_bug: "May bug",
  feedback_tag_not_understood: "Hindi niya ako maintindihan",
  feedback_tag_not_interesting: "Hindi interesante ang topic",
  feedback_tag_too_hard: "Masyadong mahirap",
  feedback_tag_too_easy: "Masyadong madali",
  feedback_tags_label_positive: "Ano ang nagustuhan mo?",
  feedback_tag_audio_issues: "Problema sa audio",
  feedback_tag_too_slow: "Masyadong mabagal",
  feedback_tag_repetitive: "Masyadong paulit-ulit",
  feedback_tag_good_topic: "Magandang topic",
  feedback_tag_right_level: "Tamang level",
  feedback_tag_good_feedback: "Magandang feedback",
  feedback_tag_understood_me: "Naunawaan ako",
  feedback_tag_learned_something: "May natutunan akong bago",
  feedback_tag_fun: "Masaya",
  feedback_tag_natural_conversation: "Natural na pag-uusap",
  feedback_comment_placeholder: "May karagdagang komento? (optional)",
  feedback_required_hint: "Pumili ng tag o magdagdag ng komento para makatulong sa amin na mag-improve.",
  feedback_sent: "Naipadala na ang puna mo!",
  error_no_selection_to_save: "Walang napiling text na ise-save.",
  error_user_not_found_for_library: "Hindi nahanap ang user. Hindi mai-save sa library.",
  text_saved_to_library_success: "Na-save sa library mo!",
  error_saving_to_library: "Hindi ma-save sa library. {{message}}",
  save_to_library_button: "I-save sa Library",
  error_no_conversation_id_for_vocab: "Hindi nahanap ang conversation context. Ise-save ang item nang wala ito.",
  save_banner_prompt: "I-save ang \"<strong>{{snippet}}</strong>\"?",
  loading_learning_plan: "Nilo-load ang plano sa pag-aaral mo...",
  generating_learning_plan: "Ginagawa ang Plano sa Pag-aaral Mo",
  planner_generation_message: "Maghintay habang ginagawa namin ang personalized mong plano sa pag-aaral. Maaari kang mag-practice gamit ang Freeform conversation habang naghihintay!",
  generating: "Ginagawa",
  plannerBeingCreated: "Ginagawa ang plano sa pag-aaral mo. Maghintay sandali...",
  planner_pending_objective: "Gumagawa ng plano para sa: \"{{objective}}\"",
  plannerCreationTimeout: "Nag-time out ang paggawa ng plano sa pag-aaral. Pakisubukang muli.",
  continue_learning_objective: "Ipagpatuloy ang learning objective mo",
  continue_learning_path: "Ipagpatuloy ang learning path",
  custom_activities_for_you: "Custom activities para sa iyo",
  loading: "Naglo-load...",
  generating_activity: "Gumagawa ng activity mo...",
  generating_activity_1: "Inaangkop ang aktibidad para sa iyo...",
  generating_activity_2: "Gumagawa ng espesyal para sa level mo...",
  generating_activity_3: "Pina-personalize ang susunod mong challenge...",
  generating_activity_4: "Gumagawa ng aktibidad batay sa interests mo...",
  generating_activity_5: "Naghahanda ng masayang exercise para sa iyo...",
  generating_activity_6: "Dinidisenyo ang personalized mong lesson...",
  generating_activity_7: "Gumagawa ng unique na activity para sa goals mo...",
  generating_activity_8: "Inihahanda ang susunod mong learning adventure...",
  loading_test_results: "Nilo-load ang test results...",
  your_learning_goal: "Learning Goal Mo",
  edit_goal: "I-edit ang Goal",
  your_learning_activities: "Learning Activities Mo",
  planner_activities_description: "Kumpletuhin ang mga aktibidad na ito sa pagkakasunod-sunod para maabot ang learning goal mo.",
  activity: "Aktibidad",
  view_learning_plan: "Tingnan ang Plano sa Pag-aaral",
  test_learning_path: "I-test ang learning path mo",
  learning_progress: "Learning Progress",
  activities: "mga aktibidad",
  start_your_first_activity: "Simulan ang unang aktibidad para masubaybayan ang progress",
  all_activities_started: "Mahusay ang progress! Nasimulan mo na ang lahat ng aktibidad",
  learning_plan_complete_title: "Natapos mo na ang learning plan mo!",
  learning_plan_complete_description: "Magaling — natapos mo lahat ng {{count}} aktibidad. Gawin ang evaluation para makita kung nasaan ka na at kung ano ang susunod na pag-aralan, tapos magtakda ng bagong layunin base doon.",
  create_new_learning_plan: "Magtakda ng bagong layunin",
  practice_activity_again: "Ulitin ang isang aktibidad",
  learning_plan_complete_hint: "Tapos na ang plano! Magtakda ng bagong layunin para magpatuloy",
  confirmNewLearningPlanAfterCompletion: "Natapos mo na ang planong ito. Ang paggawa ng bago ay papalitan ito ng mga bagong aktibidad. Ituloy?",
  keep_practicing_activities: "Tuloy lang! Ipagpatuloy ang pag-practice ng activities para gumaling",
  no_learning_goal_message: "Gumawa ng personalized plano sa pag-aaral para masubaybayan ang progress mo at maabot ang French learning goals mo.",
  set_your_learning_goal: "Itakda ang Learning Goal Mo",
  microphone_permission_required: "Kailangan ng pahintulot sa mikropono",
  microphone_permission_message: "Kailangan ng app na ito ng access sa mikropono para gumana sa real-time mode.",
  allow_microphone: "Payagan ang mikropono",
  tooltip_activities: "Mga Aktibidad",
  tooltip_planner: "Plano sa Pag-aaral",
  tooltip_feedback: "Puna",
  tooltip_more: "Higit pang Opsyon",
  close_modal: "Isara ang dialog",
  skip_to_main: "Lumaktaw sa main content",
  main_content_label: "Main content",
  speech_profile_title: "Speech Profile",
  speech_profile_instructions: "Basahin nang malakas ang bawat pangungusap para ma-calibrate namin ang speech profile mo.",
  speech_profile_no_sentences: "Wala pang diagnostic sentences para sa language combination mo. Bumalik muli mamaya.",
  speech_profile_back_to_app: "Bumalik sa App",
  speech_profile_listen: "Pakinggan",
  speech_profile_playing: "Nagpe-play...",
  speech_profile_record: "I-record",
  speech_profile_stop: "Ihinto",
  speech_profile_analyzing: "Ina-analyze ang pronunciation...",
  speech_profile_analysis_error: "Hindi ma-analyze ang pronunciation. Pakisubukang muli.",
  speech_profile_try_again: "Subukang Muli",
  speech_profile_next: "Susunod",
  speech_profile_complete_title: "Na-update ang Speech Profile!",
  speech_profile_complete_message: "Na-update na ang speech profile mo. Mas maiintindihan na ngayon ng AI ang pronunciation mo.",
  speech_profile_overall_score: "Kabuuang pronunciation score",
  speech_profile_start_practicing: "Magsimulang Mag-practice",
  analyzing_conversation: "Ina-analyze ang resulta mo...",
  analyzing_may_take_time: "Maaari itong tumagal nang hanggang isang minuto",
  results_score_overview: "Score Mo",
  results_cefr_level: "CEFR Level",
  results_oral_comprehension: "Oral Comprehension",
  results_oral_production: "Oral Production",
  results_feedback: "Personalized na Feedback",
  results_learning_plan: "Inirerekomendang Susunod na Hakbang",
  results_audio_analysis: "Audio Analysis",
  results_pronunciation: "Pronunciation",
  results_vocabulary: "Paggamit ng Bokabularyo",
  results_grammar: "Grammar at Conjugation",
  results_fluency: "Fluency",
  results_email_prompt: "Ilagay ang email mo para matanggap ang detalyadong resulta",
  contact_cta_heading: "Handa na bang pabilisin ang language learning ng team mo?",
  contact_cta_text: "Makipag-ugnayan sa amin para ma-onboard ang team mo",
  activity_not_found: "Hindi nahanap ang aktibidad",

  onboarding_native_language_title: "Ano ang iyong katutubong wika?",
  onboarding_native_language_description: "Piliin ang mother tongue mo para ma-personalize ang karanasan.",
  onboarding_more_languages: "Higit pa",
  onboarding_show_less_languages: "Mas kaunti",
  onboarding_target_language_title: "Ano ang gusto mong matutunan?",
  onboarding_target_language_description: "Piliin ang target language mo. Makakarinig ka ng mabilis na preview.",
  onboarding_age_title: "Adult ka ba?",
  onboarding_age_yes: "Oo",
  onboarding_age_no: "Hindi",
  onboarding_age_adult_description: "18 taong gulang o mas matanda",
  onboarding_age_child_description: "Wala pang 18 taong gulang",
  onboarding_age_description: "Tinutulungan kami nitong magbigay ng content na angkop sa edad.",
  onboarding_level_title: "Ano ang level mo?",
  onboarding_level_description_cefr: "Piliin ang proficiency level mo gamit ang CEFR scale.",
  onboarding_level_unknown: "Hindi sigurado",
  onboarding_level_placement_hint: "Ire-refine namin ito pagkatapos ng placement test mo.",
  cefr_a1_description: "Ganap na beginner",
  cefr_a2_description: "Basic phrases at simpleng pag-uusap",
  cefr_b1_description: "Kayang pag-usapan ang pamilyar na topics",
  cefr_b2_description: "Kayang makipag-usap sa native speakers",
  cefr_c1_description: "Fluent para sa social at professional na gamit",
  cefr_c2_description: "Halos native proficiency",
  onboarding_pronoun_title: "Ano ang pronouns mo?",
  onboarding_pronoun_description: "May ilang wika na gendered. Tinutulungan kami nitong kausapin ka nang tama.",
  terms_checkbox_label: "Sumasang-ayon ako sa",
  terms_and_conditions: "Mga Tuntunin at Kondisyon",
  onboarding_completion_title: "Handa ka na!",
  onboarding_completion_description: "Narito ang summary ng preferences mo. Maaari mo itong palitan sa settings anumang oras.",
  start_learning: "Simulan ang Pag-aaral",
  saving: "Sine-save...",
  redirecting: "Nagre-redirect...",
  onboarding_privacy_note: "Secure na naka-store ang preferences mo at ginagamit ito para ma-personalize ang learning experience mo.",
  onboarding_objective_title: "Ano ang goal mo?",
  onboarding_objective_description: "Sabihin sa amin kung ano ang gusto mong maabot para maiangkop namin ang path mo.",
  onboarding_objective_placeholder: "hal., \"Mag-present ng projects sa clients sa loob ng 6 na buwan.\"",
  onboarding_objective_or: "o",
  onboarding_objective_record: "I-record",
  onboarding_objective_stop: "Ihinto",
  onboarding_objective_start_recording: "Simulan ang voice recording",
  onboarding_objective_stop_recording: "Ihinto ang recording",
  onboarding_objective_transcribing: "Tina-transcribe...",
  onboarding_objective_mic_denied: "Tinanggihan ang microphone access. Payagan ang microphone access at subukang muli.",
  onboarding_objective_transcription_error: "Hindi na-transcribe ang audio. Pakisubukang muli o i-type ang objective mo.",
  onboarding_objective_skip_hint: "Optional. Maaari mo munang laktawan ito.",
  onboarding_objective_entered: "Nakapaglagay ka na ng learning objective.",
  onboarding_objective_aria_label: "Learning objective mo",
  onboarding_notifications_title: "Manatiling consistent",
  onboarding_finish: "Tapos",
  onboarding_notifications_description: "Mahalaga ang consistent practice. Magpapadala kami ng friendly reminders para magpatuloy ka.",
  onboarding_notifications_recommendation: "Mas epektibo ang 10-15 minuto kada araw kaysa mahahaba pero madalang na sessions.",
  onboarding_notifications_audio: "Gusto mo ba kitang padalhan ng practice reminders?",
  onboarding_notifications_yes: "Paalalahanan ako",
  onboarding_notifications_no: "Hindi na muna",
  onboarding_notifications_days_label: "Mga araw",
  onboarding_notifications_time_label: "Oras",
  onboarding_notifications_email_notice: "Magpapadala kami ng reminders sa email address mo.",
  day_mon: "Lun",
  day_tue: "Mar",
  day_wed: "Miy",
  day_thu: "Huw",
  day_fri: "Biy",
  day_sat: "Sab",
  day_sun: "Lin",
  notifications_summary_enabled: "Naka-enable ang reminders para sa {{count}} araw sa {{time}}",
  notifications_summary_disabled: "Naka-disable ang reminders",
  onboarding_calendar_description: "O idagdag sa calendar mo",
  onboarding_calendar_google: "Google Calendar",
  onboarding_calendar_outlook: "Outlook",
  onboarding_calendar_download_ics: "I-download ang .ics",
  onboarding_calendar_outlook_hint: "Tip: Gawing recurring sa Outlook pagkatapos idagdag",
  onboarding_calendar_added: "Naidagdag",
  onboarding_email_checkbox_label: "Padalhan ako ng email reminders",
  onboarding_no_reminders_warning: "Walang reminders na naka-set. Nakakatulong ang consistency para mas mabilis kang matuto!",
  // ReminderSetupCard (shown while the learning plan is generating)
  reminder_card_title: "Habang naghihintay, mag-set up ng mga paalala sa pagsasanay",
  reminder_card_subtitle: "Ang regular at maiikling sesyon ang susi sa pag-unlad.",
  reminders_saved: "Na-save na ang mga paalala!",
  day_selection: "Pagpili ng araw",
  reminder_time_selection: "Oras ng paalala",
  save_reminders: "I-save ang mga paalala",
  // Shared onboarding control (OnboardingStepControls uses the `continue` key)
  continue: "Magpatuloy",
  onboarding_step_native_language: "Katutubong Wika",
  onboarding_step_target_language: "Target Language",
  onboarding_step_age: "Edad",
  onboarding_step_level: "Level",
  onboarding_step_pronoun: "Pronoun",
  onboarding_step_objective: "Objective",
  onboarding_step_notifications: "Reminders",
  onboarding_step_completion: "Kumpleto",
  onboarding_welcome_title: "Maligayang pagdating!",
  onboarding_welcome_text: "Magsimula tayo sa ilang tanong at sa una mong work-related conversation.",
  onboarding_welcome_duration: "Mga 2 minuto ang setup, pagkatapos ay isang maikling unang pag-uusap.",
  onboarding_step_ready: "Handa",
  onboarding_ready_title: "Handa ka na!",
  onboarding_ready_description: "Susunod, magkakaroon ka ng maikling unang pag-uusap para makilala kita at maituro ang unang salita mo.",
  onboarding_ready_learning: "Pag-aaralan",
  onboarding_ready_level: "Level",
  onboarding_ready_start: "Simulan ang unang pag-uusap ko",
  onboarding_ready_not_now: "Hindi muna ngayon",
  onboarding_mic_listening: "Nakikinig... magsabi ng ilang salita",
  onboarding_mic_hear_yes: "Naririnig ko ito",
  onboarding_mic_hear_no: "Hindi ko ito marinig",
  onboarding_mic_troubleshoot: "Ayos lang. Tingnan kung tamang mikropono ang napili at naka-up ang volume, pagkatapos mag-record muli.",
  onboarding_mic_playback_confirm: "Pakinggan ang recording mo. Naririnig mo ba ang sarili mo?",
  onboarding_accept_continue: "Tanggapin at Magpatuloy",
  onboarding_back: "Bumalik",
  onboarding_how_it_works_title: "Paano ito gumagana",
  onboarding_how_it_works_text: "Naiintindihan ko ang native at target languages mo. Gagamitin ko ang pareho para tulungan kang matuto, pero subukan mong gamitin ang bagong wika hangga't maaari!",
  onboarding_level_beginner_description: "Beginner",
  level_beginner: "Beginner",
  level_intermediate: "Intermediate",
  level_advanced: "Advanced",
  level_beginner_description: "Nakakaintindi at nakakagamit ako ng basic phrases at expressions",
  level_intermediate_description: "Kaya kong makipag-usap tungkol sa pamilyar na topics at maglarawan ng experiences",
  level_advanced_description: "Kaya kong ipahayag ang sarili ko nang fluent at spontaneous sa karamihan ng sitwasyon",
  onboarding_level_title_v2: "Ano ang komportable mong gawin sa {{language}}?",
  onboarding_level_question: "Ano ang komportable mong gawin sa {{language}}?",
  language_fr: "Pranses",
  language_en: "Ingles",
  language_es: "Espanyol",
  onboarding_level_intermediate_description: "Intermediate",
  onboarding_level_advanced_description: "Advanced",
  onboarding_adaptation_title: "Paano ako aangkop sa iyo",
  onboarding_adaptation_beginner: "Sa level na **{{level}}**, gagamit ako ng {{nativeLanguage}} bilang suporta habang dahan-dahang ipinapakilala ang basics ng {{targetLanguage}}.",
  onboarding_adaptation_intermediate: "Sa level na **{{level}}**, magsasalita ako kadalasan sa {{targetLanguage}}, at gagamitin lang ang {{nativeLanguage}} para sa mas kumplikadong paliwanag.",
  onboarding_adaptation_advanced: "Sa level na **{{level}}**, mananatili tayo sa {{targetLanguage}} para mahasa ang professional fluency at idioms mo.",
  onboarding_adaptation_advanced_tip: "Tip: Subukan ang **Realtime mode** sa Settings para sa mas mabilis at tuloy-tuloy na karanasan.",
  onboarding_mic_title: "I-test ang mic mo",
  onboarding_mic_description: "Siguraduhin nating naririnig ka namin para sa mga pag-uusap mo.",
  onboarding_mic_permission_prompt: "Pakibigay ang microphone access.",
  onboarding_mic_allow: "Payagan ang Mikropono",
  onboarding_mic_requesting: "Humihingi ng access...",
  onboarding_mic_denied: "Tinanggihan ang access. I-enable ang mikropono sa browser settings mo.",
  onboarding_mic_retry: "Subukang Muli",
  onboarding_mic_skip: "Laktawan",
  onboarding_mic_ready: "Handa! I-click ang record at magsabi ng ilang salita.",
  onboarding_mic_granted: "Naibigay ang access! I-click sa ibaba para mag-record ng test.",
  onboarding_mic_tip: "Tip: Gumamit ng headphones at tahimik na lugar para sa pinakamagandang resulta.",
  onboarding_mic_recording: "Nagre-record... I-click para ihinto",
  onboarding_mic_play_back: "Magaling! Pakinggan ang recording mo:",
  onboarding_mic_success: "Gumagana nang maayos ang mikropono!",
  onboarding_mic_record_again: "Mag-record muli",
  onboarding_conversation_title: "Unang pag-uusap",
  onboarding_conversation_start_prompt: "I-click ang button at sabihin ang **{{greeting}}** para magsimula!",
  onboarding_conversation_done: "Mahusay!",
  onboarding_conversation_complete_hint: "Binubuo ang personalized mong plano...",
  onboarding_recap_title: "Kumpleto ang unang session!",
  onboarding_recap_description: "Nagawa mo na ang unang hakbang patungo sa fluency sa {{language}}.",
  onboarding_recap_accomplished: "Summary:",
  onboarding_recap_had_conversation: "Natapos ang unang pag-uusap",
  onboarding_recap_learned_word: "Natutunan ang professional vocabulary",
  onboarding_recap_personalized: "Nagawa ang personalized plan",
  onboarding_auto_objective: "Professional {{language}} batay sa intro conversation",
  onboarding_save_error: "Error. Na-save ang progress locally.",
  onboarding_achievement_title: "Kumpleto ang Day 1 ng {{language}}!",
  onboarding_achievement_summary: "Handa na ang path mo. Maaari mong simulan ang journey anumang oras!",
  onboarding_achievement_continue: "Magpatuloy",
  onboarding_achievement_stop: "Tumigil muna ngayon",

  lite_completion_title: "Mahusay!",
  lite_completion_title_name: "Mahusay, {{name}}!",
  lite_completion_subtitle: "Narito ang summary ng unang session mo at ang susunod na hakbang.",
  lite_conversation_done_title: "Katapos mo lang ng unang lesson mo!",
  lite_conversation_done_message: "Handa na ang personalized plano sa pag-aaral mo. I-unlock ang 20 tailored activities na ginawa para sa iyo.",
  lite_unlock_plan: "I-unlock ang plano sa pag-aaral ko",
  lite_recap_scenario: "Scenario na na-practice",
  lite_recap_skills: "Skills na na-practice",
  lite_recap_focus: "Mga focus area",
  lite_recap_cadence: "Inirerekomendang weekly cadence",
  lite_recap_next: "Susunod mong activities",
  lite_hr_title: "Hilingin sa employer mo na suportahan ang workplace language development mo",
  lite_hr_option_a: "Direktang ipadala sa HR team mo",
  lite_hr_email_placeholder: "Email address ng HR",
  lite_hr_send: "Ipadala",
  lite_hr_sending: "Ipinapadala...",
  lite_hr_sent: "Naipadala!",
  lite_hr_retry: "Subukang muli",
  lite_hr_sent_message: "Naipadala ang request sa HR team mo.",
  lite_hr_error_message: "May nangyaring mali. Pakisubukang muli.",
  lite_hr_or: "o",
  lite_hr_option_b: "Buksan ang pre-filled email para i-forward",
  email_work_hint: "Mas mainam ang work email para maiangkop namin ito sa workplace mo. Maaari ka pa ring magpatuloy gamit ang email na ito.",
};
